import { CSSProperties, useEffect } from "react";
import { WebViewProps } from "react-native-webview";
import { WebViewSourceUri } from "react-native-webview/lib/WebViewTypes";

type MessageType = {
    type: "redirect";
    path: string;
};

const WebView = ({ source, style, onNavigationStateChange, ...props }: WebViewProps) => {
    useEffect(() => {
        const fn = (event: { data: string }) => {
            let message: MessageType;

            if (typeof event.data === "string") {
                message = JSON.parse(event.data);
            } else {
                message = event.data;
            }
            if (message.type === "redirect") {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                window.location = `/app/${message.path}`;
            }
        };

        window.addEventListener("message", fn, false);

        return () => {
            window.removeEventListener("message", fn, false);
        };
    }, [onNavigationStateChange]);

    return (
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        <iframe
            style={{ ...(style as CSSProperties), border: "none" }}
            src={(source as WebViewSourceUri).uri}
            width="100%"
            height="100%"
            allow="autoplay; fullscreen; camera; microphone"
            {...props}
            onLoad={(e) => {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                onNavigationStateChange?.({ url: e.target.src });
            }}
        />
    );
};

export default WebView;
